import {
  getQueues,
  getQueuesByOrg,
  getCampaigns,
  getAgentsByVoiceQueue,
  getAgentsByVoiceCampaign,
  hangUpCall,
} from '@/services/voice-service';
import {
  SET_VOICE_QUEUES,
  SET_CAMPAIGNS_VOICE_AGENT,
  SET_DIALOG_EXTEN,
  ADD_MESSAGE_ERROR_DIALING,
} from '@/store/mutation-types';
import { outhersAgents } from '@/shared/utils/helpers';

const actions = {
  clearVoiceQueue({ commit }) {
    commit(SET_VOICE_QUEUES, []);
  },

  addErrorVoiceMessage({ commit }, error) {
    commit(ADD_MESSAGE_ERROR_DIALING, error);
  },

  getQueues({ commit }) {
    return getQueues()
      .then((queues) => {
        commit(SET_VOICE_QUEUES, queues);
        return queues;
      })
      .catch(window.console.error);
  },

  getQueuesByOrg({ commit }, org) {
    return getQueuesByOrg(org)
      .then((queues) => {
        commit(SET_VOICE_QUEUES, queues);
        return queues;
      })
      .catch(window.console.error);
  },

  getAgentsVoiceQueue({ commit }, { voiceQueue, agentId }) {
    commit(SET_VOICE_QUEUES, []);

    const filterAgents = outhersAgents(agentId);

    getAgentsByVoiceQueue(voiceQueue, agentId)
      .then(filterAgents)
      .then((agents) => commit(SET_VOICE_QUEUES, agents))
      .catch(window.console.error);
  },

  getAgentsVoiceCampaign({ commit, state }, { voiceCampaign, agentId }) {
    commit(SET_VOICE_QUEUES, []);

    const hasAgentsCampaign = state.agents.length;
    const filterAgents = outhersAgents(agentId);

    if (hasAgentsCampaign) return;

    getAgentsByVoiceCampaign(voiceCampaign, agentId)
      .then(filterAgents)
      .then((agents) => commit(SET_VOICE_QUEUES, agents))
      .catch(window.console.error);
  },

  getCampaignsVoiceByAgent({ commit }, agentId) {
    return getCampaigns(agentId).then((campaigns) => {
      commit(SET_CAMPAIGNS_VOICE_AGENT, campaigns);
    });
  },

  hungUpCall({ dispatch }, { call }) {
    return hangUpCall(call);
  },

  dialogExtenOpen({ commit }) {
    commit(SET_DIALOG_EXTEN, true);
  },

  dialogExtenClose({ commit }) {
    commit(SET_DIALOG_EXTEN, false);
  },

  connectWebrtc({ commit }) {},

  resetVoiceStatus({ commit }) {
    commit('RESET_VOICE_STATUS');
  },
};

export default actions;
